import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';
import { DafYear } from '../../api/useCharitableGivingQuery';

export const STEP_ID: Step = 'dafDonationYear';

export interface FormValues {
  dafDonationStartYear: DafYear | null;
  dafDonationEndYear: DafYear | null;
}

export const validation = yup.object().shape({
  dafDonationStartYear: yup
    .object()
    .nullable()
    .required('Please, enter the start year'),

  dafDonationEndYear: yup
    .object()
    .nullable()
    // eslint-disable-next-line func-names
    .test('is-greater', 'End Year cannot be before the Start Year.', function(value) {
      const { dafDonationStartYear } = this.parent;

      if (!value || !dafDonationStartYear) {
        return true;
      }

      if (!value.year) {
        return true;
      }

      return value.year >= dafDonationStartYear.year;
    }),
});
